import { forwardRef } from "react";
import { Control, FieldValues } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import InputAdornment from "@mui/material/InputAdornment";

import FormTextField from "../FormTextField";

interface NumberFormatCustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const FormCurrencyInput = forwardRef<HTMLInputElement, NumberFormatCustomProps>(
  function FormCurrencyInput({ onChange, ...other }, ref) {
    return (
      <NumericFormat
        {...other}
        decimalScale={2}
        fixedDecimalScale
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: other.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  }
);

interface FormCurrencyFieldProps<TValues extends FieldValues> {
  control: Control<TValues>;
  name: string;
  label: string;
  id: string;
  dataTestId?: string;
  disabled?: boolean;
  optional?: boolean;
  defaultValue?: string | number | null;
  required?: boolean;
  valueParser?: (value: string) => unknown;
}

export const FormCurrencyField = <TValues extends FieldValues>({
  control,
  id,
  name,
  label,
  dataTestId,
  disabled = false,
  optional = false,
  defaultValue = "",
  required = false,
  valueParser,
}: FormCurrencyFieldProps<TValues>) => {
  return (
    <FormTextField
      id={id}
      name={name}
      label={label}
      control={control}
      disabled={disabled}
      defaultValue={defaultValue}
      optional={optional}
      required={required}
      valueParser={valueParser}
      dataTestId={dataTestId}
      InputProps={{
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
        inputComponent: FormCurrencyInput as never,
      }}
      sx={{
        backgroundColor: "background.default",
      }}
    />
  );
};

export default FormCurrencyField;
